const combineReducer = (reducers) => {
  const initialState = rehydrate(reducers);
  return (state = initialState, action) => {
    return Object.keys(reducers).reduce((acc, curr) => {
      const slice = reducers[curr](state[curr], action);
      return { ...acc, [curr]: slice };
    }, state);
  };
};

const rehydrate = (reducers) => {
  return Object.keys(reducers).reduce((acc, curr) => {
    const slice = reducers[curr](undefined, { type: 'REHYDRATE' });
    return { ...acc, [curr]: slice };
  }, {});
};

const extractState = (rootKey, stateKey) => {
  const root = JSON.parse(localStorage.getItem(rootKey) || '{}');
  return root[stateKey] || {};
};

export { combineReducer, extractState };
